module.exports = __webpack_public_path__ + "static/media/tick-yellow.ee416e52.svg";